module.exports = __webpack_public_path__ + "img/cloud3_4.adc6c6ac.png";